export const domainConfigurations = [
    {
        domain: 'dev.bloomlink.bloomifai.com',
        ins_rest_url: 'https://dev-api.bloomlink.bloomifai.com/',
        ins_socker_url: 'https://dev-socket.bloomlink.bloomifai.com/',
        url: 'https://dev.virtuowltutoring.com/',
        bloomIfAI_url: 'https://api-dev.bloomifai.com',
        bloomIfAI: 'https://app-dev.bloomifai.com/login',
        appname: 'Bloomlink',
        title: 'Bloomlink',
        whitelabeled: true,
        logoType: 'Image',
        logo: '',
        logoIcon: '',
        favicon: '',
        favType: 'image/ico',
        domainPath: window.location.pathname.split('/')[1],
        bufferTiming: 2,
        finalBufferTiming: 5,
        paginationCount: 50,
        appLanguage: 'en',
        cleverLoginUrl:
            'https://clever.com/oauth/authorize?response_type=code&redirect_uri=https://dev-api.virtuowlschools.com/clever-sso/auth&client_id=4d0dad409d9866e6e864',
    },
    {
        domain: 'hcappdev.bloomlink.bloomifai.com',
        ins_rest_url: 'https://hcapidev.bloomlink.bloomifai.com/',
        ins_socker_url: 'https://hcsocketdev.bloomlink.bloomifai.com/',
        url: 'https://hcappdev.bloomlink.bloomifai.com/',
        bloomIfAI_url: 'https://api-dev.bloomifai.com',
        bloomIfAI: 'https://app-dev.bloomifai.com/login',
        appname: 'Bloomlink',
        title: 'Bloomlink',
        whitelabeled: true,
        logoType: 'Image',
        logo: '',
        logoIcon: '',
        favicon: '',
        favType: 'image/ico',
        domainPath: window.location.pathname.split('/')[1],
        bufferTiming: 2,
        finalBufferTiming: 5,
        paginationCount: 50,
        appLanguage: 'es',
    },
    {
        domain: 'hcappstage.bloomlink.bloomifai.com',
        ins_rest_url: 'https://hcapistage.bloomlink.bloomifai.com/',
        ins_socker_url: 'https://hcsocketstage.bloomlink.bloomifai.com/',
        url: 'https://hcappstage.bloomlink.bloomifai.com/',
        bloomIfAI_url: 'https://api-staging.bloomifai.com',
        bloomIfAI: 'https://app-staging.bloomifai.com/login',
        appname: 'Bloomlink',
        title: 'Bloomlink',
        whitelabeled: true,
        logoType: 'Image',
        logo: '',
        logoIcon: '',
        favicon: '',
        favType: 'image/ico',
        domainPath: window.location.pathname.split('/')[1],
        bufferTiming: 10,
        finalBufferTiming: 15,
        paginationCount: 50,
        appLanguage: 'es',
    },
    {
        domain: 'hcappstage.bloomlink.baihc.hospitalcima.net',
        ins_rest_url: 'https://hcapistage.bloomlink.baihc.hospitalcima.net/',
        ins_socker_url: 'https://hcsocketstage.bloomlink.baihc.hospitalcima.net/',
        url: 'https://hcappstage.bloomlink.baihc.hospitalcima.net/',
        bloomIfAI_url: 'https://hcapi-stage.baihc.hospitalcima.net',
        bloomIfAI: 'https://hcapp-stage.baihc.hospitalcima.net/login',
        appname: 'Bloomlink',
        title: 'Bloomlink',
        whitelabeled: true,
        logoType: 'Image',
        logo: '',
        logoIcon: '',
        favicon: '',
        favType: 'image/ico',
        domainPath: window.location.pathname.split('/')[1],
        bufferTiming: 10,
        finalBufferTiming: 15,
        paginationCount: 50,
        appLanguage: 'es',
    },
    {
        domain: 'staging.bloomlink.bloomifai.com',
        ins_rest_url: 'https://staging-api.bloomlink.bloomifai.com/',
        ins_socker_url: 'https://staging-socket.bloomlink.bloomifai.com/',
        url: 'https://stage.virtuowltutoring.com/',
        bloomIfAI_url: 'https://api-staging.bloomifai.com',
        bloomIfAI: 'https://app-staging.bloomifai.com/login',
        appname: 'Bloomlink',
        title: 'Bloomlink',
        whitelabeled: true,
        logoType: 'Image',
        logo: '',
        logoIcon: '',
        favicon: '',
        favType: 'image/ico',
        domainPath: window.location.pathname.split('/')[1],
        bufferTiming: 10,
        finalBufferTiming: 15,
        paginationCount: 50,
        appLanguage: 'en',
        cleverLoginUrl:
            'https://clever.com/oauth/authorize?response_type=code&redirect_uri=https://dev-api.virtuowlschools.com/clever-sso/auth&client_id=4d0dad409d9866e6e864',
    },
    {
        domain: 'app.bloomlink.baihc.hospitalcima.net',
        ins_rest_url: 'https://api.bloomlink.baihc.hospitalcima.net/',
        ins_socker_url: 'https://socket.bloomlink.baihc.hospitalcima.net/',
        url: 'https://app.bloomlink.baihc.hospitalcima.net/',
        bloomIfAI_url: 'https://api.bloomifai.com',
        bloomIfAI: 'https://app.bloomifai.com/login',
        appname: 'Bloomlink',
        title: 'Bloomlink',
        whitelabeled: true,
        logoType: 'Image',
        logo: '',
        logoIcon: '',
        favicon: '',
        favType: 'image/ico',
        domainPath: window.location.pathname.split('/')[1],
        bufferTiming: 10,
        finalBufferTiming: 15,
        paginationCount: 50,
        appLanguage: 'en',
    },
    {
        domain: 'corestage-app.bloomlink.bloomifai.com',
        ins_rest_url: 'https://corestage-api.bloomlink.bloomifai.com/',
        ins_socker_url: 'https://corestage-socket.bloomlink.bloomifai.com/',
        url: 'https://corestage-app.bloomlink.bloomifai.com/',
        bloomIfAI_url: 'https://api.bloomifai.com',
        bloomIfAI: 'https://app.bloomifai.com/login',
        appname: 'Bloomlink',
        title: 'Bloomlink',
        whitelabeled: true,
        logoType: 'Image',
        logo: '',
        logoIcon: '',
        favicon: '',
        favType: 'image/ico',
        domainPath: window.location.pathname.split('/')[1],
        bufferTiming: 10,
        finalBufferTiming: 15,
        paginationCount: 50,
        appLanguage: 'en',
    },
    {
        domain: 'bhate.platform.bloomlink.bloomifai.com',
        ins_rest_url: 'https://bhate-api.platform.bloomlink.bloomifai.com/',
        ins_socker_url: 'https://bhate-socket.platform.bloomlink.bloomifai.com/',
        url: 'https://bhate.platform.bloomlink.bloomifai.com/',
        bloomIfAI_url: 'https://api-dev.bloomifai.com',
        bloomIfAI: 'https://app.bhate.platform.bloomifai.com/',
        appname: 'Bhate',
        title: 'Bhate',
        whitelabeled: true,
        logoType: 'Image',
        logo: '',
        logoIcon: '',
        favicon: '',
        favType: 'image/ico',
        domainPath: window.location.pathname.split('/')[1],
        bufferTiming: 10,
        finalBufferTiming: 15,
        appLanguage: 'en',
        paginationCount: 50,
        cleverLoginUrl:
            'https://clever.com/oauth/authorize?response_type=code&redirect_uri=https://dev-api.virtuowlschools.com/clever-sso/auth&client_id=4d0dad409d9866e6e864',
    },
    {
        domain: 'demo.virtuowlschools.com',
        ins_rest_url: 'https://demo-api.virtuowlschools.com/',
        ins_socker_url: 'https://demo-socket.virtuowlschools.com/',
        url: 'https://demo.virtuowlschools.com/',
        appname: 'VirtuOwl',
        title: 'VirtuOwl',
        whitelabeled: true,
        logoType: 'Image',
        logo: '',
        logoIcon: '',
        favicon: '',
        favType: 'image/ico',
        domainPath: window.location.pathname.split('/')[1],
        bufferTiming: 10,
        finalBufferTiming: 15,
        appLanguage: 'en',
        paginationCount: 50,
        cleverLoginUrl:
            'https://clever.com/oauth/authorize?response_type=code&redirect_uri=https://demo-api.virtuowlschools.com/clever-sso/auth&client_id=4d0dad409d9866e6e864',
    },
    {
        domain: 'bloomlink.bloomifai.com',
        ins_rest_url: 'https://api.bloomlink.bloomifai.com/',
        ins_socker_url: 'https://socket.bloomlink.bloomifai.com/',
        url: 'https://virtuowlschools.com/',
        bloomIfAI_url: 'https://api.bloomifai.com',
        bloomIfAI: 'https://app.bloomifai.com/login',
        appname: 'Bloomlink',
        title: 'Bloomlink',
        whitelabeled: true,
        logoType: 'Image',
        logo: '',
        logoIcon: '',
        favicon: '',
        favType: 'image/ico',
        domainPath: window.location.pathname.split('/')[1],
        bufferTiming: 10,
        finalBufferTiming: 15,
        paginationCount: 50,
        appLanguage: 'en',
        cleverLoginUrl:
            'https://clever.com/oauth/authorize?response_type=code&redirect_uri=https://api.virtuowlschools.com/clever-sso/auth&client_id=9083c967fac7204b3c53',
    },
    {
        domain: 'localhost',
        ins_rest_url: 'https://dev-api.bloomlink.bloomifai.com/',
        ins_socker_url: 'https://dev-socket.bloomlink.bloomifai.com/',
        url: 'https://virtuowltutoring.com/',
        bloomIfAI_url: 'https://api-dev.bloomifai.com',
        bloomIfAI: 'https://app-dev.bloomifai.com/login',
        appname: 'Bloomlink',
        title: 'Bloomlink',
        whitelabeled: true,
        logoType: 'Image',
        logo: '',
        logoIcon: '',
        favicon: '',
        favType: 'image/ico',
        domainPath: window.location.pathname.split('/')[1],
        bufferTiming: 2,
        finalBufferTiming: 5,
        paginationCount: 50,
        appLanguage: 'en',
        cleverLoginUrl:
            'https://clever.com/oauth/authorize?response_type=code&redirect_uri=https://dev-api.virtuowlschools.com/clever-sso/auth&client_id=4d0dad409d9866e6e864',
    },
    {
        domain: 'default',
        ins_rest_url: 'https://dev-api.bloomlink.bloomifai.com/',
        ins_socker_url: 'https://dev-socket.bloomlink.bloomifai.com/',
        url: 'https://virtuowlschools.com/',
        appname: 'VirtuOwl',
        title: 'VirtuOwl',
        whitelabeled: true,
        logoType: 'Image',
        logo: '',
        logoIcon: '',
        favicon: '',
        favType: 'image/ico',
        domainPath: window.location.pathname.split('/')[1],
        bufferTiming: 10,
        finalBufferTiming: 15,
        paginationCount: 50,
        appLanguage: 'en',
        cleverLoginUrl:
            'https://clever.com/oauth/authorize?response_type=code&redirect_uri=https://api.virtuowlschools.com/clever-sso/auth&client_id=9083c967fac7204b3c53',
    },
];

// Languages the app ships translations for.
export const SUPPORTED_LANGUAGES = ['en', 'es'];

// Key the invite link's language is remembered under for the life of the tab.
const LINK_LANGUAGE_KEY = 'sessionLinkLanguage';

// A third party joins straight from an invite link that carries the language
// the session was created in (`?language=es`). They never log in, so that link
// is the only language signal for the tab - remember it so it survives any
// in-app navigation that drops the query string.
export const getLinkLanguage = () => {
    try {
        const fromUrl = String(
            new URLSearchParams(window.location.search).get('language') || ''
        )
            .trim()
            .toLowerCase();
        if (SUPPORTED_LANGUAGES.includes(fromUrl)) {
            sessionStorage.setItem(LINK_LANGUAGE_KEY, fromUrl);
            return fromUrl;
        }
        const remembered = sessionStorage.getItem(LINK_LANGUAGE_KEY);
        return SUPPORTED_LANGUAGES.includes(remembered) ? remembered : null;
    } catch (error) {
        // Private browsing can make sessionStorage throw on access.
        return null;
    }
};

export const fetchDomainConfiguration = () => {
    const hostname = window.location.hostname;

    const baseConfig =
        domainConfigurations.find((c) => c.domain === hostname) ||
        domainConfigurations.find((c) => c.domain === 'default');
    const resolvedType = process.env.REACT_APP_DOMAIN_TYPE;
    const isHealthCare = resolvedType !== 'CORE' ? true : false;

    // The invite link wins: a third party has no stored preference, and a
    // preference left in this browser by a signed-in user is not theirs.
    const userLanguage =
        getLinkLanguage() ||
        (isHealthCare
            ? localStorage.getItem('preferredLanguage') ||
              localStorage.getItem('user_language') ||
              baseConfig?.appLanguage ||
              'en'
            : baseConfig?.appLanguage || 'en');

    return {
        ...baseConfig,
        appLanguage: userLanguage,
        type: resolvedType,
        isHealthCare,
        domainPath: window.location.pathname.split('/')[1],
        labels: isHealthCare
            ? {
                  channel: 'patient',
                  channelName: 'patientName',
                  teamMemberName: 'doctorName',
                  channelnotes: 'patientNotes',
              }
            : {
                  channel: 'channel',
                  channelName: 'channelName',
                  teamMemberName: 'teamMemberName',
                  channelnotes: 'channelNotes',
              },
    };
};

const AppConfig = fetchDomainConfiguration();
export default AppConfig;
